import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Row,
    RightComponents,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
} from '../../components/Form';
import {
    TableData,
    TableHeader,
    TableBody,
    TableRow,
    TableColumn,
} from '../../components/Table';
import {
    MobileInfoBox,
    Title,
    TextView,
    PanelBox,
    Modal,
} from '../../components/Display';
import MembershipTransactionTypesDelete from '../financial/MembershipTransactionTypesDelete';
import MembershipTransactionTypesNew from '../financial/MembershipTransactionTypesNew';
import MembershipTransactionTypesEdit from '../financial/MembershipTransactionTypesEdit';
import { postData } from '../../Api';

export default function TaroffTransactionTypes(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const handlecomp1 = () => {
        setModal(
            Modal({
                children: <MembershipTransactionTypesNew onDismiss={() => setModal(null)} />,
                onDismiss: () => setModal(null),
            })
        );
    };
    const [tableData, setTableData] = useState({});
    const [tableSize, setTableSize] = useState(parseInt(allProps['size']) || 20);
    const [tablePage, setTablePage] = useState(parseInt(allProps['page']) || 1);
    const gotoPage = (page, size = undefined) => {
        setTableData({});
        setTablePage(page);
        size && setTableSize(size);
        setSearchParams({ ...searchParams, page: page, size: size || tableSize });
    };
    const clearFilters = () => {
        setSearchParams({});
    };
    const applyFilters = () => {
        const newSearchParams = {};
        navigate({ search: '?' + new URLSearchParams(newSearchParams).toString() });
    };
    useEffect(() => {
        postData('/api/panel/page/taroff-transaction-types/table-data', {
            size: tableSize,
            page: tablePage,
        }).then((response) => {
            setTableData(response.data);
        });
    }, [searchParams, modal, props]);
    const handlecomp2 = (row) => {
        setModal(
            Modal({
                children: (
                    <MembershipTransactionTypesEdit
                        membership-transaction-types-id={row.param_id}
                        onDismiss={() => setModal(null)}
                    />
                ),
                onDismiss: () => setModal(null),
            })
        );
    };
    const handlecomp3 = (row) => {
        setModal(
            Modal({
                children: (
                    <MembershipTransactionTypesDelete
                        membership-transaction-types-id={row.param_id_2}
                        onDismiss={() => setModal(null)}
                    />
                ),
                onDismiss: () => setModal(null),
            })
        );
    };
    return (
        <PanelBox>
            <Row>
                <RightComponents>
                    <Title>نوع تراکنش ها</Title>
                </RightComponents>
                <LeftComponents>
                    <Button onClick={handlecomp1} color={'secondary'}>
                        ایجاد نوع
                    </Button>
                </LeftComponents>
            </Row>
            <TableData total={tableData.total} size={tableSize} page={tablePage} setPage={gotoPage}>
                <TableHeader>
                    <TableRow>
                        <TableColumn mobile={true}>mobile</TableColumn>
                        <TableColumn mobile={false}>شناسه</TableColumn>
                        <TableColumn mobile={false}>عنوان</TableColumn>
                        <TableColumn mobile={false}>کلید یکتا</TableColumn>
                        <TableColumn mobile={false}>زمان ایجاد</TableColumn>
                        <TableColumn mobile={false}></TableColumn>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {tableData.rows?.map((row, index) => (
                        <TableRow key={index}>
                            <TableColumn mobile={true}>
                                <MobileInfoBox />
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_id}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView bold={true}>{row.text_title}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView backColor={row.color_color}>{row.text_key}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView format={'persian-date-normal'}>
                                    {row.text_inserttime}
                                </TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <LeftComponents>
                                    <Button
                                        onClick={() => handlecomp2(row)}
                                        rightIcon={'far fa-edit'}
                                        tooltip={'ویرایش'}
                                    ></Button>
                                    <Button
                                        onClick={() => handlecomp3(row)}
                                        color={'warn'}
                                        rightIcon={'far fa-trash'}
                                        tooltip={'حذف'}
                                    ></Button>
                                </LeftComponents>
                            </TableColumn>
                        </TableRow>
                    ))}
                </TableBody>
            </TableData>
            {modal && modal}
        </PanelBox>
    );
}
